import React from "react";
import { type GalleryData } from "../../utils/mockProjects";

interface GalleryProps {
  gallery: GalleryData;
}
export const Gallery: React.FC<GalleryProps> = ({ gallery }) => {
  return (
    <div className="w-full h-fit flex flex-col items-center justify-between gap-10 md:pb-24  text-primary">
      <div className="w-full md:py-16 flex md:flex-row md:gap-0 gap-8 flex-col font-gilroy-bold">
        <div className="w-1/4 lg:text-2xl md:text-xl text-lg">Gallery</div>

        <div className="md:w-3/4 lg:text-5xl md:text-2xl text-base">
          <p className="lg:w-3/4 font-gilroy-light">{gallery.quote}</p>
        </div>
      </div>

      <div className="w-screen lg:grid lg:grid-cols-3 grid-cols-2 gap-1 overflow-hidden ">
        {gallery.galleryImages.map((media, index) => (
          <div
            className={`grid-cols-1 lg:w-[33.2vw] flex items-center justify-center overflow-hidden`}
            key={index}
          >
            {media.endsWith(".webm") ? (
              <video
                playsInline
                key={index}
                src={media}
                controls
                loop
                autoPlay
                muted
                className="object-cover lg:w-full w-screen h-full"
              />
            ) : media.endsWith(".webp") ? (
              <img
                key={index}
                src={media}
                alt={`Gallery image ${index + 1}`}
                className="object-cover w-full h-full lg:block hidden"
              />
            ) : null}
          </div>
        ))}
      </div>

      <div className="lg:w-[40vw] md:w-[60vw] py-2 md:self-end self-center lg:space-y-8 space-y-2">
        <p className="font-gilroy-bold lg:text-5xl md:text-2xl text-xl leading-[1] md:text-start text-center">
          Want to build something similar to this for your brand ?
        </p>

        <div className="flex gap-8 md:justify-start justify-center items-center">
          <p className="text-primary font-gilroy-bold">Let's connect</p>
          <div>
            <img
              onClick={() =>
                (window.location.href = "mailto:sales@tagglabs.in")
              }
              src="/button.svg"
              alt="Button"
              className="md:w-[52px] w-[32px] md:h-[52px] h-[32px] cursor-pointer"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
